import React from 'react';

// containers
import ProfileIndex from 'containers/profile/ProfileIndex';
import ProfileAlbum from 'containers/profile/ProfileAlbum';
import ProfileAmateurFilms from 'containers/profile/ProfileAmateurFilms';
import ProfileWallPosts from 'containers/profile/ProfileWallPosts';
import ProfileWishlist from 'containers/profile/ProfileWishlist';
import ProfileGuestbook from 'containers/profile/ProfileGuestbook';
import Member from 'containers/member/Member';
import UiKitPage from 'containers/UiKitPage';
import BuyXXL from 'containers/BuyXXL';
import faq from 'containers/Faq';
import cgu from 'containers/Cgu';
import VirtualGifts from 'containers/VirtualGifts';
// import enter from 'containers/Enter';
import registration from 'containers/Registration';
import login from 'containers/Login';
import contacts from 'containers/Contacts';
import popularsearches from 'containers/PopularSearches';
import upload from 'containers/Upload';
import Wishlists from 'containers/Wishlists';
import Test from 'containers/Test';
import IndexContainer from 'containers/Index';
import ProfilesContainer from 'containers/Profiles';
import RoomUserList from 'containers/RoomUserList';
import NotFound from 'containers/NotFound';
import ActivateRegistration from 'containers/ActivateRegistration';

import MaterialList from 'components/materialList';
import materialPage from 'components/materialPage';

import paths from 'paths';

let routes = [
    // done
    {path: '/', component: IndexContainer, exact: true},
    {path: paths.buyXXL.path, component: BuyXXL},
    {path: paths.faq.path, component: faq},
    {path: paths.cgu.path, component: cgu},
    {path: paths.member.path, component: Member},
    {path: paths.activateRegistration.path, component: ActivateRegistration},

    {path: paths.profiles.path, component: ProfilesContainer},
    {path: paths.profile.path, component: ProfileIndex, exact: true},
    {path: paths.profileAlbum.path, component: ProfileAlbum},
    {path: paths.profileAmateurFilms.path, component: ProfileAmateurFilms},
    {path: paths.profileWallMaterials.path, component: ProfileWallPosts},
    {path: paths.profileWishlist.path, component: ProfileWishlist},
    {path: paths.profileGuestbook.path, component: ProfileGuestbook},

    {path: paths.login.path, component: login},
    {path: paths.register.path, component: registration},
    {path: paths.virtualGifts.path, component: VirtualGifts},
    {path: '/room-user-list', component: RoomUserList},
    {path: '/test', component: Test},
    {path: '/ui-kit', component: UiKitPage},
    {path: paths.amateurFilm.path, component: materialPage},
    {path: paths.amateurFilms.path, render: (routeProps) => (<MaterialList {...routeProps} kind='videos'/>)},
    {path: paths.wallMaterial.path, component: materialPage},
    {path: paths.wall.path, render: (routeProps) => (<MaterialList {...routeProps} kind='wall'/>)},
    {path: paths.wardrobe.path, render: (routeProps) => (<MaterialList {...routeProps} kind='wardrobe'/>)},
    {path: paths.contact.path, component: contacts},
    {path: paths.wishlists.path, component: Wishlists},
    // not ready yet
    // {path: '/enter', component: enter},
    {path: '/popularsearches', component: popularsearches},
    {path: '/upload', component: upload},

    {path: undefined, component: NotFound} // 404
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js